import fieldMixin from '@maison/mixins/fieldMixin';
import textFieldMixin from '@phoenix/mixins/textFieldMixin';

export default {
  mixins: [fieldMixin, textFieldMixin],

  props: {
    rows: {
      type: Number,
      default: 5,
    },
  },
};
